module.exports = __webpack_public_path__ + "media/svg/neutral_light_solo-382b2cad.svg";